export const LANGUAGE_CHANGE = "LANGUAGE_CHANGE";